// temporary solution for storing ticket footer info, until Epic CMS is not integrated
const footerCenterLines = [
    'SUPERBET ZAKŁADY BUKMACHERSKIE SP Z O.O.',
    'UL. WINCENTEGO RZYMOWSKIEGO 31, 02-697',
    'WARSZAWA',
];

export default {
    nsoft: {
        qa: {
            footerCenterLines,
            configHost: 'https://superbet-content-stage.global.ssl.fastly.net/cached-superbet/app-config?country=pl&environment=qa&platform=ssbt',
            paymentHost: 'https://retail.betting.stage.superbet.pl/api/',
            paymentHostSocket: 'https://retail.betting.stage.superbet.pl/betting-terminal-ssbt',
            socketPath: '/api/socket.io',
            countryKey: 'pl',
            allowancesUrl: 'https://superbet-content-stage.freetls.fastly.net/cached-superbet/allowances/pl',
            virtualTournamentsEndpoint: 'https://sports-offer.s3.eu-central-1.amazonaws.com/virtual-tournaments/pl.json',
        },
        silent: {
            footerCenterLines,
            configHost: 'https://superbet-content.global.ssl.fastly.net/cached-superbet/app-config?country=pl&environment=prod&platform=ssbt',
            paymentHost: 'https://retail.betting.superbet.pl/silent/rest-api/',
            paymentHostSocket: 'https://retail.betting.superbet.pl/betting-terminal-ssbt',
            socketPath: '/silent/rest-api/socket.io',
            countryKey: 'pl',
            allowancesUrl: 'https://superbet-content-stage.freetls.fastly.net/cached-superbet/allowances/pl',
            virtualTournamentsEndpoint: 'https://sports-offer.s3.eu-central-1.amazonaws.com/virtual-tournaments/pl.json',
        },
        prod: {
            footerCenterLines,
            configHost: 'https://superbet-content.global.ssl.fastly.net/cached-superbet/app-config?country=pl&environment=prod&platform=ssbt',
            paymentHost: 'https://retail.betting.superbet.pl/rest-api/',
            paymentHostSocket: 'https://retail.betting.superbet.pl/betting-terminal-ssbt',
            socketPath: '/rest-api/socket.io',
            countryKey: 'pl',
            allowancesUrl: 'https://superbet-content-stage.freetls.fastly.net/cached-superbet/allowances/pl',
            virtualTournamentsEndpoint: 'https://sports-offer.s3.eu-central-1.amazonaws.com/virtual-tournaments/pl.json',
        }
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/terminal/poland/config/devEnvironment.ts